'use client'

import MerchantBenefits from "@/src/interfaces/benefits/merchant"
import { createContext, ReactNode, useContext, useState } from "react"

interface PromotionContextType {
  promotion?: MerchantBenefits.PromotionResponse
  setPromotion: (promotion: MerchantBenefits.PromotionResponse) => void
  setCanShowPromotion(e: boolean): void
  canShowPromotion: boolean
}

const PromotionContext = createContext<PromotionContextType | undefined>(undefined)

export const PromotionProvider = ({ children }: { children: ReactNode }) => {
  const [promotion, setPromotion] = useState<MerchantBenefits.PromotionResponse>()
  const [canShowPromotion, setCanShowPromotion] = useState<boolean>(false)

  return (
    <PromotionContext.Provider value={{ promotion, setPromotion, canShowPromotion, setCanShowPromotion }}>
      {children}
    </PromotionContext.Provider>
  )
}

export const usePromotion = (): PromotionContextType => {
  const context = useContext(PromotionContext)

  if (!context)
    throw new Error('O contexto de Promotion deve estar dentro do PromotionProvider.')

  return context
}